import { ButtonMedium } from '@components/core-ui/form-elements/buttons/Button/variations/PrimaryButtonSizes';
import CheckEmail from '@components/icons/CheckEmail.svg';
import { useInitContext } from '@providers/InitProvider';
import React from 'react';
import { Wrapper } from './styles';
import { StyledIconWrapper } from './styles/StyledIconWrapper';

export const AccountDisabledPage = () => {
  const { logout } = useInitContext();

  const goToLogin = (evt: React.MouseEvent<HTMLButtonElement>) => {
    evt.preventDefault();
    logout();
  };

  return (
    <Wrapper>
      <div className="root">
        <StyledIconWrapper>
          <CheckEmail className="checkEmailIcon" />
        </StyledIconWrapper>
        <h1 className="great">Error!</h1>
        <h2 className="accountDeactivated">This account has been deactivated</h2>
        <h2 className="pleaseContact">Please contact support if you wish to activate it.</h2>

        <ButtonMedium onClick={goToLogin}>Go back to Sign In</ButtonMedium>
      </div>
    </Wrapper>
  );
};
